import BaseClass from "../BaseClass.js";

/**
 * setzt die Sichtbarkeit von Dom-Elementen und dis- bzw. enabled InputFields innerhalb
 *
 * toggleActions:
 * show - Target wird eingeblendet, wenn aktiv (Radiobox)
 * hide - Target wird ausgeblendet, wenn aktiv (Radiobox)
 * toggle - Target wird eingeblendet, wenn aktiv ... ansonsten ausgeblendet (Checkbox)
 * toggle_reverse - Target wird ausgeblendet, wenn aktiv ... ansonsten eingeblendet (Checkbox)
 */
export default class ActionButton extends BaseClass {

    constructor(element) {
        super(element);

        this.elementState = null;
        this.toggleAction = null;
        this.toggleTarget = null;
        this.toggleListener = null;

        this.init();
    }

    init() {
        let mySelf = this;
        this.toggleAction = this.$element.data('toggle-action');
        this.toggleTarget = this.$element.data('toggle-target');
        this.toggleListener = function () {
            mySelf.setTarget();
        }
        mySelf.setTarget();
        this.$element.on('change', this.toggleListener);

    }

    setTarget() {
        let mySelf = this;

        this.elementState = this.$element.is(':checked');

        if (this.elementState == true) {
            if (this.toggleAction == 'show' || this.toggleAction == 'toggle') {
                mySelf.show();
            } else {
                mySelf.hide();
            }
        } else {
            if (this.toggleAction == 'show' || this.toggleAction == 'toggle') {
                mySelf.hide()
            } else {
                mySelf.show();
            }
        }
    }

    show() {
        let $container = $(this.toggleTarget);
        let $inputs = $container.find('input,select,textarea,button');
        let $checkboxes = $container.find('input[type=checkbox]');

        $container.removeClass('hidden');

        $inputs.prop('disabled', false);
        $checkboxes.prop('checked', false); // Checkboxen in Grundstellung
    }

    hide() {
        let $container = $(this.toggleTarget);

        let $inputs = $container.find('input,select,textarea,button');
        let $checkboxes = $container.find('input[type=checkbox]');

        $container.addClass('hidden');

        $inputs.prop('disabled', true);
        $checkboxes.prop('checked', false);
    }

    destroyListener() {
        this.$element.off('change', this.toggleListener);
    }

}